/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundCreateRequestDto
 */
export interface FundCreateRequestDto {
  /**
   *
   * @type {string}
   * @memberof FundCreateRequestDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FundCreateRequestDto
   */
  fundGroupId: string | null;
}

export function FundCreateRequestDtoFromJSON(json: any): FundCreateRequestDto {
  return FundCreateRequestDtoFromJSONTyped(json, false);
}

export function FundCreateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundCreateRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
    fundGroupId: json["fundGroupId"],
  };
}

export function FundCreateRequestDtoToJSON(value?: FundCreateRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    fundGroupId: value.fundGroupId,
  };
}
